import { KeycloakProfile } from 'keycloak-js';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

export class CadastroUsuario {

  id: number;
  nome: string;
  nomeSocial: string;
  tipoPessoa: string;
  tipoDocumento: string;
  cpfcnpj: string;
  dataNascimento: Date;
  numeroDocumento: string;
  orgaoExpedidor: string;
  ufOrgaoExpedidor: string;
  dataExpedicao: Date;
  escolaridade: string;
  email: string;
  confirmacaoEmail: string;
  confirmacaoSenha: string;
  senha: string;
  cep: string;
  logradouro: string;
  numero: string;
  complemento: string;
  bairro: string;
  municipio: string;
  uf: string;
  pais: string;
  ddd: string;
  telefone: string;
  genero: string;
  nomeResponsavel: string;
  contatoResponsavel: string;
  nomeDoRepresentante: string;
  atividadeEconomica: string;
  telefoneResid: string;
  telefoneCom: string;
  telefoneCel: string;
  origem: string;
  username: string;
  createdModifiedOn: Date;
  dataAlteracao: Date;
	usernameOperadorCriacao: string;
  ativo: string;
  prioridadePessoaIdosa: boolean;

  isAuthenticated: boolean;

  constructor(perfilKeycloak?: KeycloakProfile) {

    if (perfilKeycloak) {

      this.nome = perfilKeycloak.firstName;
      this.username = perfilKeycloak.username;
      this.email = perfilKeycloak.email;
      this.isAuthenticated = true;

    }

  }

}
